import(/* webpackMode: "eager" */ "/app/src/app/(pages)/dieu-khoan-va-dich-vu/page.tsx");
